import { PageWrapper } from '@connectedComponents';
import { useController } from './useController';
import { FC, useCallback } from 'react';
import { stackEnum } from '@utilities/enums';
import { CategoryForm, ProductForm } from '../components';
import { GradientPicker, Loading } from '@components';

export const AddArticlesPage: FC = () => {

    const {
        createCategorySuccess, createProductSuccess,
        tabs, activeTab, createCategoryError,
        createProductLoading, createProductError,
        categories, createCategoryLoading,
        getAllOrganisationCategoriesLoading,
        handleTabSwitch, handleBackClick,
        onCreateCategory, onCreateProduct,
    } = useController();

    const renderTabs = useCallback(() => {
        switch (activeTab) {
            case 0:
                return <GradientPicker />;
            case 1:
                return (
                    <ProductForm 
                        categories={categories} 
                        loading={createProductLoading}
                        error={createProductError}
                        sussessMessage={createProductSuccess}
                        onCreateProduct={onCreateProduct}
                    />
                );
            case 2:
                return (
                    <CategoryForm 
                        loading={createCategoryLoading || getAllOrganisationCategoriesLoading}
                        error={createCategoryError}
                        sussessMessage={createCategorySuccess}
                        handleCreateCategory={onCreateCategory}
                    />
                );
            default:
                return 1;
        }
    }, [
        activeTab, categories, createProductLoading,
        createProductError, createProductSuccess,
        createCategoryLoading, getAllOrganisationCategoriesLoading,
        createCategoryError, createCategorySuccess,
        onCreateProduct, onCreateCategory
    ]);

    return (
        <PageWrapper
            activeStack={stackEnum.stocksStack}
            handleGoBack={handleBackClick}
        >
            <h2
                className="text-xl sm:text-2xl md:text-2xl font-bold mb-4"
            >
                Ajouter un nouvel article
            </h2>

            <div className="space-y-4">

                <div
                    role="tablist"
                    className="tabs bg-white tabs-boxed mb-6 
                    col-span-full shadow overflow-x-auto h-14"
                >
                    {
                        tabs.map((tab, index) => (
                            <span
                                key={index}
                                role="tab"
                                className={`
                                        text-sm truncate whitespace-nowrap h-12
                                        tab ${activeTab === tab.index ? 'tab-active' : ''
                                    }`
                                }
                                onClick={() => handleTabSwitch(tab.index)}
                            >
                                {tab.label}
                            </span>
                        ))
                    }
                </div>

                {renderTabs()}
            </div>

            <Loading isLoading={createProductLoading} />
        </PageWrapper>
    );
};

